var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "#C4C4C4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 0C9.82618 0 7 2.82618 7 6.3C7 9.77382 9.82618 12.6 13.3 12.6C16.7738 12.6 19.6 9.77382 19.6 6.3C19.6 2.82618 16.7738 0 13.3 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0348 20.4113C20.8683 18.2115 17.9962 17 14.9475 17H11.4305C8.38187 17 5.50971 18.2115 3.3432 20.4113C1.1873 22.6003 0 25.4898 0 28.5477C0 29.0333 0.393677 29.427 0.879266 29.427H25.4987C25.9843 29.427 26.378 29.0333 26.378 28.5477C26.378 25.4898 25.1907 22.6003 23.0348 20.4113Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBtn);
export default __webpack_public_path__ + "static/media/userBtn.f95c4afb.svg";
export { ForwardRef as ReactComponent };